// extracted by mini-css-extract-plugin
export default {"operationArea":"Device_operationArea__mV3SV"};